export interface Translation {
  _id?: string
  language: string
  title: string
  description: string
}

export interface Category {
  _id?: string
  title: string
  description: string
  status: 'active' | 'inactive'
  translations: Translation[]
}

export const initialCategory: Omit<Category, '_id'> = {
  title: '',
  description: '',
  status: 'active',
  translations: []
} 